import { useRecoilValue } from 'recoil';

import { ia } from 'lib/helpers/utility';

import { currentPractice } from 'components/practice/practiceState';
import Typography from 'components/shared/Typography/Typography';

const PracticeInformation = () => {
  const practice = useRecoilValue(currentPractice);

  const fields = [
    { value: practice?.name, weight: 'medium' },
    { value: practice?.tax_id, color: 'neutral-700' },
    { value: practice?.address, color: 'neutral-700' },
    { value: practice?.phone, color: 'neutral-700' },
    { value: practice?.email, color: 'neutral-700' }
  ].filter((field) => !!field.value);

  if (!ia(fields)) return null;

  return (
    <div className="flex flex-col border-0 border-b border-solid border-b-neutral-200 px-4 py-3">
      <div className="flex flex-col">
        {fields.map((field, idx) => (
          <Typography
            key={idx}
            variant="p"
            size="small"
            weight={field.weight}
            color={field.color}
            className="whitespace-normal">
            {field.value}
          </Typography>
        ))}
      </div>
    </div>
  );
};

export default PracticeInformation;
